import styled from 'styled-components'
import { colors, fonts, DEVICE } from '../../../../util/StellaConstant'

/*
    @media ${DEVICE.mobileS} {

    }
    @media ${DEVICE.laptop} {

    }
    @media ${DEVICE.laptopL} {

    }
*/

export const Title = styled.p`
	@media ${DEVICE.mobileS} {
		font-family: ${fonts.HiraKakuProW6};
		font-size: 20px;
		color: ${colors.pearlAqua};
		margin-bottom: 14px;
		font-weight: 700;
	}
	@media ${DEVICE.laptop} {
		font-family: ${fonts.HiraginoKakuGothicPro};
		font-size: 26px;
		margin-bottom: 14px;
	}
	@media ${DEVICE.laptopL} {
		font-family: ${fonts.HiraginoKakuGothicPro};
		font-size: 27px;
		margin-bottom: 14px;
	}
`

export const Content = styled.p`
	@media ${DEVICE.mobileS} {
		font-family: ${fonts.HiraKakuProW3};
		font-size: 15px;
		color: ${colors.mediumBlue};
		line-height: 20px;
		margin-bottom: 22px;
	}
	@media ${DEVICE.laptop} {
		font-family: ${fonts.HiraginoKakuGothicPro};
		font-size: 22px;
		line-height: 21px;
		margin-bottom: 71px;
	}
	@media ${DEVICE.laptopL} {
		font-size: 17px;
		margin-bottom: 41px;
	}
`

export const Ruler = styled.div`
	@media ${DEVICE.mobileS} {
		width: 100%;
		height: 1px;
		background-color: ${colors.gainsboro};
		margin-bottom: 6px;
	}
	@media ${DEVICE.laptop} {
		display: none;
	}
	@media ${DEVICE.laptopL} {

	}
`

export const CheckboxArea = styled.div`
	@media ${DEVICE.mobileS} {
		margin-bottom: 35.5px;
		display: flex;
		flex-direction: column;
		padding-left: 5px;
	}
	@media ${DEVICE.laptop} {
		margin-bottom: 35.5px;
		padding-left: 13px;
	}
	@media ${DEVICE.laptopL} {
		margin-bottom: 38.5px;
		padding-left: 5px;
	}
`
export const ButtonArea = styled.div`
	@media ${DEVICE.mobileS} {
		display: flex;
		justify-content: center;
		align-items: center;
	}
	@media ${DEVICE.laptop} {
		display: flex;
		justify-content: center;
		align-items: center;
	}
	@media ${DEVICE.laptopL} {
		display: flex;
		justify-content: center;
		align-items: center;
	}
`

export const Button = styled.button`
	@media ${DEVICE.mobileS} {
		font-family: ${fonts.HiraginoKakuGothicPro};
		font-size: 14px;
		color: ${(props) =>
		props.buttonType === 'ACCEPT' ? colors.white : colors.mediumBlue};
		border: none;
		outline: none;
		background-color: ${(props) =>
		props.buttonType === 'ACCEPT'
			? colors.pearlAqua
			: colors.ghostWhite};
		border-radius: 2px;
		box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.24),
			0 0 2px 0 rgba(0, 0, 0, 0.12);
		padding: 11px 43px;
	}
	@media ${DEVICE.laptop} {
		font-family: ${fonts.HiraginoKakuGothicPro};
		font-size: 18px;
		color: ${(props) =>
		props.buttonType === 'ACCEPT' ? colors.white : colors.mediumBlue};
		border: none;
		outline: none;
		background-color: ${(props) =>
		props.buttonType === 'ACCEPT'
			? colors.pearlAqua
			: colors.ghostWhite};
		border-radius: 2px;
		box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.24),
			0 0 2px 0 rgba(0, 0, 0, 0.12);
		padding: 11px 23px 11px 25px;
	}
	@media ${DEVICE.laptopL} {
		border: none;
		outline: none;
		background-color: ${(props) =>
		props.buttonType === 'ACCEPT'
			? colors.pearlAqua
			: colors.ghostWhite};
		border-radius: 2px;
		box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.24),
			0 0 2px 0 rgba(0, 0, 0, 0.12);
		font-family: ${fonts.HiraginoKakuGothicPro};
		font-size: 15px;
		color: ${(props) =>
		props.buttonType === 'ACCEPT' ? colors.white : colors.mediumBlue};
		padding: 11px 58.5px 10px 58.5px;
	}
`